import { useTranslate } from "@refinedev/core";
import { Create } from "@refinedev/antd";
import {
    Drawer,
    DrawerProps,
    Form,
    FormProps,
    Input,
    InputNumber,
    Radio,
    Select,
    Space,
    ButtonProps,
    Avatar,
    Typography,
    Upload,
    Grid,
    DatePicker,
} from "antd";
import 'dayjs/locale/sv';
import locale from 'antd/es/date-picker/locale/sv_SE';

const { Text } = Typography;

import { APP_WRITE_SUBSCRIPTION_ID } from "utility/constants";
import { CustomerSelectOptions } from "components/customerSelectOption";

type CreateProps = {
    drawerProps: DrawerProps;
    formProps: FormProps;
    saveButtonProps: ButtonProps;
};

export const CreateSubscription: React.FC<CreateProps> = ({
    drawerProps,
    formProps,
    saveButtonProps
}) => {
    const t = useTranslate();
    const breakpoint = Grid.useBreakpoint();

    const { customerSelectProps } = CustomerSelectOptions();

    return (
      <Drawer
        {...drawerProps}
        width={breakpoint.sm ? "500px" : "100%"}
        zIndex={1001}
      >
        <Create
          title={"Skapa driftabonnemang"}
          saveButtonProps={saveButtonProps}
          resource={APP_WRITE_SUBSCRIPTION_ID}
          goBack={false}
          contentProps={{
            style: {
              boxShadow: "none",
            },
            bodyStyle: {
              padding: 0,
            },
          }}
        >
          <Form {...formProps} layout="vertical">
            <Form.Item
              label="Namn"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Kund" name="customerId">
              <Select
                placeholder="Välj kund"
                style={{ width: "100%" }}
                {...customerSelectProps}
              />
            </Form.Item>
            <Form.Item
              label="Förlängningsperiod (månader)"
              name="interval"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <InputNumber min={1}  step="1" addonAfter="mån"/>
            </Form.Item>
            <Form.Item
              label="Pris"
              name="price"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <InputNumber min={1}  step="1" addonAfter="kr/mån"/>
            </Form.Item>
            <Form.Item
              label="Utgångsdatum"
              name="expireDate"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker locale={locale} />
            </Form.Item>
          </Form>
        </Create>
      </Drawer>
    );
};
